(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ethereheal-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eh-carousel')) {
  customElements.define('eh-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.eh-carousel-track');
      this.buttons = [...this.querySelectorAll('[data-direction]')];
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const card = this.track.querySelector('.eh-carousel-card');
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({left: Number(button.dataset.direction) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, {signal}));
      this.track.addEventListener('scroll', () => this.update(), {passive:true,signal});
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.buttons[0].disabled = this.track.scrollLeft < 2;
      this.buttons[1].disabled = this.track.scrollLeft > max - 2;
      const cards = [...this.track.querySelectorAll('.eh-carousel-card')];
      const width = cards[0]?.getBoundingClientRect().width || 1;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const index = Math.min(cards.length, Math.round(this.track.scrollLeft / (width + gap)) + 1);
      this.querySelector('.eh-carousel-counter').textContent = `${index} / ${cards.length}`;
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["regen-customer-reviews"] && !Shopify.designMode) return;
  try {
    
function initReferenceReviews(scope=document){scope.querySelectorAll('[data-rn-reviews]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const dialog=section.querySelector('dialog');const opener=section.querySelector('[data-rn-review-open]');opener.addEventListener('click',()=>dialog.showModal());section.querySelector('[data-rn-review-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});dialog.addEventListener('close',()=>opener.focus({preventScroll:true}));if(dialog.querySelector('[data-rn-form-result]'))dialog.showModal();});}
initReferenceReviews();document.addEventListener('shopify:section:load',event=>initReferenceReviews(event.target));

function initReviewStructure(scope=document){
  scope.querySelectorAll('[data-rn-reviews]').forEach(section=>{
    if(section.dataset.structureReady)return;
    section.dataset.structureReady='true';
    const grid=section.querySelector('.rn-review-grid');
    const cards=Array.from(grid.querySelectorAll('.rn-review-card'));
    const desktop=matchMedia('(min-width: 750px)');
    const arrange=()=>{
      if(!desktop.matches){grid.replaceChildren(...cards);return;}
      const columns=Array.from({length:3},()=>{const column=document.createElement('div');column.className='rn-review-column';return column;});
      cards.forEach((card,index)=>columns[index%3].append(card));
      grid.replaceChildren(...columns);
    };
    arrange();desktop.addEventListener('change',arrange);
    cards.forEach(card=>{
      const key='forge-review-vote:'+card.dataset.rnReviewId;
      const buttons=Array.from(card.querySelectorAll('[data-rn-vote]'));
      let vote=null;
      try{vote=localStorage.getItem(key);}catch{}
      const update=()=>buttons.forEach(button=>{const selected=vote===button.dataset.rnVote;button.setAttribute('aria-pressed',String(selected));button.querySelector('[data-rn-vote-count]').textContent=String((Number(button.dataset.rnBase)||0)+(selected?1:0));});
      update();
      buttons.forEach(button=>button.addEventListener('click',()=>{vote=vote===button.dataset.rnVote?null:button.dataset.rnVote;try{if(vote)localStorage.setItem(key,vote);else localStorage.removeItem(key);}catch{}update();}));
    });
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(section))desktop.removeEventListener('change',arrange);},{once:true});
  });
}
initReviewStructure();document.addEventListener('shopify:section:load',event=>initReviewStructure(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["regen-transformations"] && !Shopify.designMode) return;
  try {
    
function initNutraCarousels(scope=document){
  scope.querySelectorAll('[data-rn-carousel]').forEach(section=>{
    if(section.dataset.ready)return;
    section.dataset.ready='true';
    const track=section.querySelector('.rn-transform-track');
    const cards=Array.from(track.children);
    if(cards.length<2)return;
    const editor=Boolean(window.Shopify&&Shopify.designMode);
    let busy=false;
    const step=()=>cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap);
    const behavior=()=>matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth';
    if(!editor){
      const clone=card=>{const copy=card.cloneNode(true);copy.removeAttribute('data-shopify-editor-block');copy.setAttribute('aria-hidden','true');copy.inert=true;return copy;};
      const before=document.createDocumentFragment(),after=document.createDocumentFragment();
      cards.forEach(card=>{before.append(clone(card));after.append(clone(card));});
      track.prepend(before);track.append(after);
      requestAnimationFrame(()=>track.scrollTo({left:step()*cards.length,behavior:'instant'}));
    }
    const normalize=()=>{
      if(editor)return;
      const length=step()*cards.length;
      if(track.scrollLeft<length-step()/2)track.scrollTo({left:track.scrollLeft+length,behavior:'instant'});
      else if(track.scrollLeft>=length*2-step()/2)track.scrollTo({left:track.scrollLeft-length,behavior:'instant'});
      busy=false;
    };
    let timer;
    track.addEventListener('scroll',()=>{clearTimeout(timer);timer=setTimeout(normalize,160);},{passive:true});
    const move=direction=>{
      if(busy)return;
      busy=true;
      let next=track.scrollLeft+step()*direction;
      if(editor){const max=track.scrollWidth-track.clientWidth;if(next>max+2)next=0;if(next<0)next=max;}
      track.scrollTo({left:next,behavior:behavior()});
      setTimeout(()=>{busy=false;},600);
    };
    section.querySelector('[data-rn-prev]')?.addEventListener('click',()=>move(-1));
    section.querySelector('[data-rn-next]')?.addEventListener('click',()=>move(1));
    track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
    section.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.rn-transform-card');if(card)track.scrollTo({left:card.offsetLeft-track.offsetLeft,behavior:behavior()});});
  });
}
initNutraCarousels();
document.addEventListener('shopify:section:load',event=>initNutraCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-home-header"] && !Shopify.designMode) return;
  try {
    
function initHomeHeader(scope=document){scope.querySelectorAll('[data-sh-deadline]').forEach(clock=>{if(clock.dataset.ready)return;clock.dataset.ready='true';const deadline=Date.parse(clock.dataset.shDeadline);if(!Number.isFinite(deadline))return;const update=()=>{const seconds=Math.max(0,Math.floor((deadline-Date.now())/1000));clock.hidden=seconds<=0;clock.querySelector('[data-sh-hours]').textContent=String(Math.floor(seconds/3600)).padStart(2,'0');clock.querySelector('[data-sh-minutes]').textContent=String(Math.floor(seconds%3600/60)).padStart(2,'0');clock.querySelector('[data-sh-seconds]').textContent=String(seconds%60).padStart(2,'0');};update();const timer=setInterval(()=>{if(!clock.isConnected){clearInterval(timer);return;}update();},1000);});scope.querySelectorAll('.sh-mobile-nav').forEach(menu=>menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}}));}initHomeHeader();document.addEventListener('shopify:section:load',event=>initHomeHeader(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-home-reviews"] && !Shopify.designMode) return;
  try {
    
function initHomeReviews(scope=document){
 scope.querySelectorAll('[data-sh-reviews]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const viewport=root.querySelector('.sh-review-viewport');const cards=Array.from(viewport.children);const count=cards.length;
  if(count<2){root.querySelectorAll('.sh-review-arrow,.sh-review-controls').forEach(el=>el.hidden=true);return;}
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');const dots=Array.from(root.querySelectorAll('[data-sh-dot]'));const toggle=root.querySelector('[data-sh-pause]');
  let paused=Boolean(window.Shopify&&Shopify.designMode),hover=false,focused=false,pointer=false,visible=true,hold=0,last=0,current=0,frame=0,unit=0,cycle=0,width=0,travel=0;
  const speed=Number(root.dataset.speed)||24;
  const clone=card=>{const copy=card.cloneNode(true);copy.removeAttribute('data-shopify-editor-block');copy.setAttribute('aria-hidden','true');copy.inert=true;return copy;};
  const before=document.createDocumentFragment(),after=document.createDocumentFragment();cards.forEach(card=>{before.append(clone(card));after.append(clone(card));});viewport.prepend(before);viewport.append(after);
  function mark(){if(!unit)return;current=((Math.floor((viewport.scrollLeft-cycle+unit*.5)/unit)%count)+count)%count;dots.forEach((dot,i)=>{if(i===current)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});}
  function normalize(){if(!cycle||pointer)return;if(viewport.scrollLeft<cycle-unit)viewport.scrollLeft+=cycle;else if(viewport.scrollLeft>=2*cycle)viewport.scrollLeft-=cycle;}
  function measure(){const nextWidth=viewport.clientWidth;if(nextWidth===width&&unit)return;width=nextWidth;unit=cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(viewport).columnGap);cycle=unit*count;viewport.scrollTo({left:cycle+current*unit,behavior:'instant'});mark();}
  function move(index){hold=performance.now()+1800;viewport.scrollTo({left:cycle+index*unit,behavior:reduced.matches?'instant':'smooth'});}
  root.querySelector('[data-sh-prev]').addEventListener('click',()=>move(current-1));root.querySelector('[data-sh-next]').addEventListener('click',()=>move(current+1));
  dots.forEach((dot,index)=>dot.addEventListener('click',()=>move(index)));
  toggle.setAttribute('aria-pressed',String(paused));toggle.addEventListener('click',()=>{paused=!paused;toggle.setAttribute('aria-pressed',String(paused));});
  viewport.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(current+(event.key==='ArrowRight'?1:-1));}});
  root.addEventListener('mouseenter',()=>hover=true);root.addEventListener('mouseleave',()=>hover=false);root.addEventListener('focusin',()=>focused=true);root.addEventListener('focusout',event=>{focused=root.contains(event.relatedTarget);});
  viewport.addEventListener('pointerdown',()=>pointer=true,{passive:true});const release=()=>{if(pointer){pointer=false;hold=performance.now()+2000;}};window.addEventListener('pointerup',release);window.addEventListener('pointercancel',release);
  viewport.addEventListener('wheel',()=>hold=performance.now()+2000,{passive:true});viewport.addEventListener('scroll',()=>{normalize();mark();},{passive:true});
  const resize=new ResizeObserver(measure);resize.observe(viewport);const observer=new IntersectionObserver(entries=>visible=entries[0].isIntersecting);observer.observe(root);
  function tick(now){if(!root.isConnected){resize.disconnect();observer.disconnect();window.removeEventListener('pointerup',release);window.removeEventListener('pointercancel',release);return;}const elapsed=last?Math.min(now-last,50):0;last=now;if(cycle&&visible&&!document.hidden&&!paused&&!hover&&!focused&&!pointer&&!reduced.matches&&now>hold){travel+=elapsed*speed/1000;const pixels=Math.floor(travel);if(pixels){viewport.scrollLeft+=pixels;travel-=pixels;}normalize();mark();}frame=requestAnimationFrame(tick);}
  measure();document.fonts?.ready.then(measure);frame=requestAnimationFrame(tick);
  root.addEventListener('shopify:block:select',event=>{const card=event.target.closest('[data-sh-review]');if(card){paused=true;toggle.setAttribute('aria-pressed','true');move(Number(card.dataset.shReview));}});
 });
}
initHomeReviews();document.addEventListener('shopify:section:load',event=>initHomeReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-home-ticker"] && !Shopify.designMode) return;
  try {
    
function initHomeTickers(scope=document){scope.querySelectorAll('[data-sh-ticker]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';root.querySelector('[data-sh-ticker-pause]').addEventListener('click',event=>{const paused=root.dataset.paused!=='true';root.dataset.paused=String(paused);event.currentTarget.setAttribute('aria-pressed',String(paused));});});}initHomeTickers();document.addEventListener('shopify:section:load',event=>initHomeTickers(event.target));

  } catch(e) { console.error(e); }
})();
})();
